export const allWorkflowItemType = [
  {
    title: "工作表",
    list: [
      {
        name: "新增",
        type: "ServiceInsertSheet",
        icon: "workflow_create",
        class: "bg-yellow"
      },
      {
        name: "更新",
        type: "ServiceUpdateSheet",
        icon: "workflow_update",
        class: "bg-yellow"
      },
      {
        name: "删除",
        type: "ServiceDeleteSheet",
        icon: "workflow_delete",
        class: "bg-yellow"
      },
      {
        name: "锁定/解锁",
        type: "ServiceLock",
        icon: "workflow_lock",
        class: "bg-yellow"
      },
      {
        name: "设置参与人",
        type: "ServiceSetPart",
        icon: "workflow_participant",
        class: "bg-yellow"
      },
      {
        name: "数据同步",
        type: "ServiceDataSync",
        icon: "workflow_data-sync",
        class: "bg-yellow"
      }
    ]
  },
  {
    title: "构件",
    list: [
      {
        name: "分支",
        type: "Gateway",
        icon: "workflow_gateway",
        class: "bg-blue"
      },
      {
        name: "查找",
        type: "ServiceSearchMulti",
        icon: "workflow_search",
        class: "bg-blue"
      },
      {
        name: "运算",
        type: "ServiceCompute",
        icon: "workflow_compute",
        class: "bg-blue",
        dataType: "date"
      },
      {
        name: "延时",
        type: "TimerDelay",
        icon: "workflow_delay",
        class: "bg-blue"
      },
      {
        name: "子流程",
        type: "SubProcess",
        icon: "workflow_sub-process",
        class: "bg-blue"
      },
      {
        name: "校验",
        type: "ServiceValidate",
        icon: "workflow_validate",
        class: "bg-blue"
      },
      {
        name: "查找用户",
        type: "ServiceGetUser",
        icon: "workflow_search-people",
        class: "bg-blue"
      },
      {
        name: "获取打印文件",
        type: "ServicePdf",
        icon: "workflow_pdf",
        class: "bg-blue"
      }
    ]
  },
  {
    title: "人工",
    list: [
      {
        name: "审批",
        type: "UserVerify",
        icon: "workflow_verify",
        class: "bg-red"
      },
      {
        name: "发送通知",
        type: "ServiceNotify",
        icon: "workflow_notify",
        class: "bg-red"
      }
      // {
      //   name: "填写",
      //   type: "UserFillSheet",
      //   icon: "workflow_el-icon-edit",
      //   class: "bg-skyblue"
      // }
    ]
  },
  {
    title: "开发",
    list: [
      {
        name: "网络请求",
        type: "ServiceHttp",
        icon: "workflow_http",
        class: "bg-violet"
      },
      {
        name: "代码块",
        type: "ServiceScript",
        icon: "workflow_script",
        class: "bg-violet"
      },
      {
        name: "子流程出参",
        type: "SubProcessRes",
        icon: "workflow_sub-process-res",
        class: "bg-violet"
      }
    ]
  },
  {
    title: "第三方",
    list: [
      {
        name: "电子签章",
        type: "UserSeal",
        icon: "workflow_seal",
        class: "bg-green"
      }
    ]
  }
]

export const taskWorkflowItemType = [
  {
    title: "构件",
    list: [
      {
        name: "分支",
        type: "Gateway",
        icon: "workflow_gateway",
        class: "bg-blue"
      }
    ]
  },
  {
    title: "人工",
    list: [
      {
        name: "审批",
        type: "UserVerify",
        icon: "workflow_verify",
        class: "bg-red"
      },
      {
        name: "发送通知",
        type: "ServiceNotify",
        icon: "workflow_notify",
        class: "bg-red"
      }
    ]
  }
]

export const workflowStyleMap = {
  workFlowStart: {
    START_TYPE_DATA: {
      avatarBg: "bg-yellow-trigger",
      avatarIcon: "workflow_trigger_sheet",
      nameBg: "bg-yellow-trigger"
    },
    START_TYPE_TIME: {
      avatarBg: "bg-blue-trigger",
      avatarIcon: "workflow_trigger_time",
      nameBg: "bg-blue-trigger"
    },
    START_TYPE_CRON: {
      avatarBg: "bg-blue-trigger",
      avatarIcon: "workflow_trigger_cron",
      nameBg: "bg-blue-trigger"
    },
    START_TYPE_BTN: {
      avatarBg: "bg-yellow-trigger",
      avatarIcon: "workflow_trigger_button",
      nameBg: "bg-yellow-trigger"
    },
    START_TYPE_TASK: {
      avatarBg: "bg-yellow-trigger",
      avatarIcon: "workflow_trigger_task",
      nameBg: "bg-yellow-trigger"
    },
    START_TYPE_SUB: {
      avatarBg: "bg-blue-trigger",
      avatarIcon: "workflow_trigger_sub-process",
      nameBg: "bg-blue-trigger"
    },
    START_TYPE_VALIDATE: {
      avatarBg: "bg-blue-trigger",
      avatarIcon: "workflow_trigger_validate",
      nameBg: "bg-blue-trigger"
    },
    START_TYPE_HTTP: {
      avatarBg: "bg-blue-trigger",
      avatarIcon: "workflow_trigger_http",
      nameBg: "bg-blue-trigger"
    }
  },
  // UserFillSheet: {
  //   avatarBg: "bg-gray",
  //   avatarIcon: "workflow_el-icon-user-solid",
  //   nameBg: "bg-skyblue"
  // },
  UserVerify: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_verify",
    nameBg: "bg-red"
  },
  // ServiceSearch: {
  //   avatarBg: "bg-gray",
  //   avatarIcon: "workflow_search",
  //   nameBg: "bg-blue"
  // },
  ServiceUpdateSheet: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_update",
    nameBg: "bg-yellow"
  },
  ServiceInsertSheet: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_create",
    nameBg: "bg-yellow"
  },
  ServiceDeleteSheet: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_delete",
    nameBg: "bg-yellow"
  },
  ServiceNotify: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_notify",
    nameBg: "bg-red"
  },
  ServiceSearchMulti: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_search",
    nameBg: "bg-blue"
  },
  ServiceGetUser: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_search-people",
    nameBg: "bg-blue"
  },
  ServicePdf: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_pdf",
    nameBg: "bg-blue"
  },
  ServiceCompute: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_compute",
    nameBg: "bg-blue"
  },
  ServiceHttp: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_http",
    nameBg: "bg-violet"
  },
  ServiceScript: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_script",
    nameBg: "bg-violet"
  },
  SubProcessRes: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_sub-process-res",
    nameBg: "bg-violet"
  },
  TimerDelay: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_delay",
    nameBg: "bg-blue"
  },
  SubProcess: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_sub-process",
    nameBg: "bg-blue"
  },
  ServiceValidate: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_validate",
    nameBg: "bg-blue"
  },
  ServiceLock: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_lock",
    nameBg: "bg-yellow"
  },
  ServiceSetPart: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_participant",
    nameBg: "bg-yellow"
  },
  ServiceDataSync: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_data-sync",
    nameBg: "bg-yellow"
  },
  UserSeal: {
    avatarBg: "bg-gray",
    avatarIcon: "workflow_seal",
    nameBg: "bg-green"
  }
}

export const functions = [
  {
    label: "BOM",
    options: [
      {
        label: "获取BOM详情",
        value: "Utils.getBOMData(dataId, sheetId, cid, itemCid, numCid)",
        explain: {
          name: "getBOMData",
          description: "递归查询BOM详情",
          params: "dataId,sheetId,cid,itemCid,numCid",
          output: "BOM详情"
        }
      }
    ]
  },
  {
    label: "加解密",
    options: [
      {
        label: "MD5加密",
        value: "Utils.MD5(str)",
        explain: {
          name: "MD5",
          description: "32位md5",
          params: "str",
          output: "32位字符串"
        }
      },
      {
        label: "Base64编码",
        value: "Utils.encodeBase64(str)",
        explain: {
          name: "encodeBase64",
          description: "Base64编码",
          params: "str",
          output: "Base64编码"
        }
      },
      {
        label: "Base64解码",
        value: "Utils.decodeBase64(str)",
        explain: {
          name: "decodeBase64",
          description: "Base64解码",
          params: "str",
          output: "解码后的结果"
        }
      },
      {
        label: "AES加密",
        value: "Utils.aesEncrypt(str, key)",
        explain: {
          name: "aesEncrypt",
          description: "AES加密方式：AES/ECB/PKCS5Padding",
          params: "str, key:密钥",
          output: "Base64编码后的结果"
        }
      },
      {
        label: "AES解密",
        value: "Utils.aesDecrypt(str, key)",
        explain: {
          name: "aesDecrypt",
          description: "AES加密方式：AES/ECB/PKCS5Padding",
          params: "str, key:密钥",
          output: "解码后的结果"
        }
      }
    ]
  }
]

export const systemControls = [
  { name: "创建人", _cid: "cid", _type: "staff" },
  { name: "负责人", _cid: "oid", _type: "staff" },
  { name: "参与人", _cid: "pts", _type: "staff" },
  { name: "最后修改人", _cid: "upid", _type: "staff" },
  { name: "创建时间", _cid: "cat", _type: "time", timeType: "年月日时分秒" },
  { name: "最后修改时间", _cid: "uat", _type: "time", timeType: "年月日时分秒" }
]

export const options = [
  { label: "升序", value: "ASC" },
  { label: "降序", value: "DESC" }
]

export const editUserMap = {
  addSignUser: "新建签署人",
  editSignUser: "编辑签署人",
  addStartUser: "新建发起人",
  editStartUser: "编辑发起人"
}

export const credentials = [
  {
    label: "大陆身份证",
    value: "大陆身份证"
  },
  {
    label: "台湾来往大陆通行证",
    value: "台湾来往大陆通行证"
  },
  {
    label: "澳门来往大陆通行证",
    value: "澳门来往大陆通行证"
  },
  {
    label: "香港来往大陆通行证",
    value: "香港来往大陆通行证"
  },
  {
    label: "护照",
    value: "护照"
  }
]
